export default __webpack_public_path__ + "static/media/linkedin-3.64988d36.svg";